export default __webpack_public_path__ + "static/slider-1-afd8d84f131c598697b226c0ba5e201c.jpg";